import React, { useRef, useEffect } from 'react';
import { TextField, TextFieldProps } from '@mui/material';

interface PlainTextAreaProps extends Omit<TextFieldProps, 'multiline'> {
  value?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const stripHtmlTags = (html: string): string => {
  return html.replace(/<[^>]*>/g, '');
};

export const PlainTextArea: React.FC<PlainTextAreaProps> = ({
  value,
  onChange,
  ...textFieldProps
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const cursorPositionRef = useRef<number>(0);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.setSelectionRange(cursorPositionRef.current, cursorPositionRef.current);
    }
  }, [value]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      cursorPositionRef.current = event.target.selectionStart || 0;
      
      const cleanValue = stripHtmlTags(event.target.value);
      const syntheticEvent = {
        ...event,
        target: {
          ...event.target,
          value: cleanValue,
          name: event.target.name
        }
      };
      onChange(syntheticEvent as React.ChangeEvent<HTMLInputElement>);
    }
  };

  return (
    <TextField
      {...textFieldProps}
      multiline
      value={value || ''}
      onChange={handleChange}
      inputRef={inputRef}
    />
  );
};

export default PlainTextArea;